// Domain constants cho màn admin daily-task — gộp các dropdown lặp giữa
// DailyTaskPage (filter) và ModalUpdateDailyTask (form). Trước đây danh sách
// group được paste rời ở 2 chỗ, sửa 1 chỗ là dễ quên chỗ kia.

export const DAILY_TASK_GROUPS = [
    "Tặng quà phòng kara",
    "Tặng quà bài thu",
    "Tặng quà combo",
    "Tặng lì xì",
    "Tặng quà cặp đôi",
    "Thu âm đơn ca",
    "Thu âm song ca",
    "Thu âm đơn ca có hình",
    "Thu âm song ca có hình",
    "Thích bài thu",
    "Bình luận bài thu",
    "Chia sẻ bài thu",
    "Nhặt lì xì",
    "Vào phòng kara",
    "Vào phòng talk",
    "Vào phòng game",
    "Chơi game",
    "Nhắn tin bạn bè",
    "Hoàn thành hồ sơ",
    "Tham gia sự kiện",
    "Theo dõi bạn bè",
    "Xử lý AI",
    "Nghe bài thu",
    "Được bạn bè tặng quà",
    "Mua VIP",
    "Nạp Icoin",
    "Ghép cặp đôi",
    "Song ca cùng thần tượng",
    "Lên bài",
    "Lên ghế",
    "Tạo beat chờ song ca",
    "Ghé thăm bạn bè",
    "Thu âm có sticker",
];

export const TASK_TYPES = [
    { value: "NEW_USER", label: "NEW USER" },
    { value: "NORMAL", label: "NORMAL" },
];

export const TASK_RANKS = [
    { value: "EASY", label: "EASY" },
    { value: "NORMAL", label: "NORMAL" },
    { value: "HARD", label: "HARD" },
];

// 6 screenId có sẵn handler ở `buildDeepLink` của microservice game.
// LƯU Ý: 3 screen `NewUser_*` hiện chưa port đầy đủ (TODO KF-XXX trong
// vnapps.ikara.game.dailytask.service.UserDailyTaskService#buildDeepLink) —
// admin set vẫn lưu được, nhưng mobile client sẽ nhận deepLink=null cho 3 screen này.
export const FIXED_SCREEN_OPTIONS = [
    { value: "NewUser_Profile", label: "NewUser_Profile" },
    { value: "NewUser_Ask4Duet_Profile", label: "NewUser_Ask4Duet_Profile" },
    { value: "NewUser_Recording", label: "NewUser_Recording" },
    { value: "ActiveLiveRoom", label: "ActiveLiveRoom" },
    { value: "ActiveTalkRoom", label: "ActiveTalkRoom" },
    { value: "Game_LuckyDice", label: "Game_LuckyDice" },
];
